export default {
  name: 'modal',
  props: {
    className: String,
    disableBgClose: {
      type: Boolean,
      default: false,
    },
    disableEscClose: {
      type: Boolean,
      default: false,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    modalDialogClicked($event) {
      if (!this.disableBgClose) {
        $event.stopPropagation()
      }
    },
    close(source) {
      if (source === 'bg' && this.disableBgClose) return

      this.$emit('close')
    },
    onEscapeKeypress(e) {
      if (this.disableEscClose) return

      if (e.keyCode === 27) {
        this.close()
      }
    },
  },
  created() {
    document.addEventListener('keydown', this.onEscapeKeypress)
  },
  destroyed() {
    document.removeEventListener('keydown', this.onEscapeKeypress)
  },
}



// WEBPACK FOOTER //
// ./src/components/Modal/script.js?vue&type=script&lang=js&